import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[documentDropZone]',
    standalone: false
})
export class DocumentDropZoneDirective {
    @Output() private filesDroppedEmitter: EventEmitter<File[]> = new EventEmitter();

    constructor() { }

    @HostListener('drop', ['$event']) public onDrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.dataTransfer.dropEffect = 'copy';

        let files = evt.dataTransfer.files;
        let fileList: Array<File> = [];
        if (files.length > 0) {
            for (let i = 0; i < files.length; i++) {
                fileList.push(files[i]);
            }
            this.filesDroppedEmitter.emit(fileList);
        }
    }
}
